import { render } from "./Contact.vue?vue&type=template&id=38a4ad6e"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=38a4ad6e&lang=css"

import exportComponent from "/home/davlu/Documentos/Repositorios/ProyectosWeb/luisdtorresp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__